<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>Current Electoral College Projections based on Polling Data</h1>
      <p>
        On the front page, I display the electoral college vote distribution as if the election were today, based on the most recent polling data.  I only include poll data from pollsters that have at least a "B-" rating from
        <a href=https://fivethirtyeight.com/>FiveThirtyEight.com/</a>
      </p>

      <div v-if="ev_data_ready">
        <div v-for="(category_item, category) in ev_data" v-bind:key="category">
          <h3>{{category}} - {{category_item.total_ev}} electoral votes</h3>
          <ul>
            <div v-for="(group, subgroup) in category_item.ev_by_group" v-bind:key="subgroup">
              <b>{{subgroup}} : {{group.total}} electoral votes</b>
              <div class="states_listing">
                <div class="state_item" v-for="state in group.states" v-bind:key="state.state">
                  <span class="state_label">{{state.state}}</span>
                  <span class="state_bar_wrapper">
                    <span
                      v-bind:style="{width: ((state.ev/55)*100 + '%')}"
                      class="state_bar"
                      v-bind:class="[ candidate(category), likelihood(subgroup) ]"
                    >{{state.ev}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </div>

      <div v-else>
        <h2>Loading Electoral College Data...</h2>
        <div class="loading">
          <!-- Loading SVG from https://github.com/SamHerbert/SVG-Loaders -->
          <img src="/img/loading-vertical-bars.svg" width="100%" />
        </div>
      </div>

      <h2>About Polling Data</h2>To learn more about how we curate the polling data, check out our page,
      <router-link class="page_nav_link" to="/about_polling_data">About Our Polling Data.</router-link>
      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "AboutElectoralCollege",
  components: {
    DashHeader
  },
  data() {
    return {
      ev_data: {},
      ev_data_ready: false,
      cache_info: {}
    };
  },
  computed: {},
  created() {
    this.get_ev_data();
  },
  destroyed() {},

  methods: {
    candidate(category) {
      if (category.includes("Trump")) {
        return "trump";
      } else if (category.includes("Biden")) {
        return "biden";
      }
    },
    likelihood(category) {
      if (category.includes("Solid")) {
        return "solid";
      } else if (category.includes("Likely")) {
        return "likely";
      } else if (category.includes("Lean")) {
        return "lean";
      } else if (category.includes("Too Close")) {
        return "too_close";
      }
    },
    async get_ev_data() {
      let request = await fetch("/api/get_electoral_groups");
      if (request.ok) {
        let json = await request.json();
        this.ev_data = json.data;
        this.ev_data_ready = true;
        this.cache_info = json.cache_info;
      }
    }
  }
};
</script>
<style scoped>
div {
  text-align: left;
}
.img_wrapper {
  text-align: center;
}
li {
  margin-left: 30pt;
}
.state_item {
  position: relative;
  display: block;
  width: 100%;
  color: black;
}
.state_label {
  padding-left: 2ch;
  display: inline-block;
  width: 35%;
  min-width: 35%;
}
.state_bar_wrapper {
  display: inline-block;
  position: relative;
  width: 65%;
}
.state_bar {
  display: inline-block;
  height: 100%;
  opacity: 1;
  padding: 1px;
  border: 1px solid white;
  color: whitesmoke;
}
.state_bar.solid.trump {
  background-color: #a61c00;
}
.state_bar.likely.trump {
  background-color: #dd7e6b;
}
.state_bar.lean.trump {
  background-color: #f4cccc;
  color: black;
}
.state_bar.solid.biden {
  background-color: #435f8e;
}
.state_bar.likely.biden {
  background-color: #6582b2;
}
.state_bar.lean.biden {
  background-color: #729adb;
}
.state_bar.too_close {
  background-color:#b7b7b7; 
}
.loading {
  width: 70%;
  padding: 30px;
  background-color: #435f8e; 
  opacity: 0.5;
}
</style>